var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "新增车辆",
        visible: _vm.dialogVisible,
        width: "500px",
        "before-close": _vm.handleCancel
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "vehicleForm",
          attrs: {
            model: _vm.formData,
            rules: _vm.rules,
            "label-width": "100px",
            "label-suffix": "："
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "车牌号", prop: "licensePlateNum" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入" },
                model: {
                  value: _vm.formData.licensePlateNum,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "licensePlateNum", $$v)
                  },
                  expression: "formData.licensePlateNum"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "司机", prop: "name" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入" },
                model: {
                  value: _vm.formData.name,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "name", $$v)
                  },
                  expression: "formData.name"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "联系方式", prop: "tel" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入", maxlength: "11" },
                on: { input: _vm.handleTelInput },
                model: {
                  value: _vm.formData.tel,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "tel", $$v)
                  },
                  expression: "formData.tel"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "身份证", prop: "idCard" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入" },
                model: {
                  value: _vm.formData.idCard,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "idCard", $$v)
                  },
                  expression: "formData.idCard"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "实发数量", prop: "actualSendQuantity" } },
            [
              _c("el-input-number", {
                staticStyle: { width: "100%" },
                attrs: {
                  label: "请输入",
                  precision: 4,
                  min: 0,
                  max: 999999999,
                  step: 1,
                  placeholder: "请输入"
                },
                model: {
                  value: _vm.formData.actualSendQuantity,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "actualSendQuantity", $$v)
                  },
                  expression: "formData.actualSendQuantity"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handleCancel } }, [
            _vm._v("取消")
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleConfirm } },
            [_vm._v("确定")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }